<template>
  <div>
    <rent-kebab-view
      :items="filteredItems"
      :parent-event="parentEvent"
      :params-data="params.data"
    />
  </div>
</template>
<script>
import RentKebabView from "./RentKebabView.vue";
export default {
  name: "DoNotRentKebabFilter",
  props: {
    parentEvent: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {
    RentKebabView,
  },
  computed: {

    filteredItems() {
      let items = [
        {
          text: "Edit",
          event: "edit",
        },
        {
          text: "Remove",
          event: "remove",
        },
      ];
      return items;
    },
  },
};
</script>
